import type { RedcatAnalyticsStore } from '../types/store';
import type { PaymentEventBase } from '../types/payment';
import { PaymentTrackEventName } from '../types/payment';
import type { PaymentTrackEvent } from '../types/events/track';
import { paymentEventProperties } from './paymentEventProperties';

export const trackPaymentSucceeded = (
  track: RedcatAnalyticsStore['track'],
  args: PaymentEventBase,
) => {
  const event: PaymentTrackEvent = {
    name: PaymentTrackEventName.PaymentSucceeded,
    properties: {
      ...paymentEventProperties(args),
      response_timedate: new Date().toISOString(),
    },
  };

  track(event);
};
